<template>
    <div class="container-fluid">
        <h1>{{ $t('systems') }}</h1>

        <div :class="$style['form-grid']">
            <b-form-group :label="$t('system_name')">
                <b-form-input v-model="inputSystemName" size="sm" ref="systemname"/>
            </b-form-group>
            <b-form-group :label="$t('economy_type')">
                <b-form-select v-model="inputSystemType" size="sm">
                    <optgroup v-for="(group, index) in economies.types" :label="$t(group.title)" :key="index">
                        <option v-for="(sub, index) in group.subs" :value="sub" :key="index">{{ $t(sub) }}</option>
                    </optgroup>
                </b-form-select>
            </b-form-group>
            <b-form-group :label="$t('system_wealth')">
                <b-form-select v-model="inputSystemWealth" size="sm">
                    <optgroup v-for="(group, index) in economies.levels" :label="$t(group.title)" :key="index">
                        <option v-for="(sub, index) in group.subs" :value="sub" :key="index">{{ $t(sub) }}</option>
                    </optgroup>
                </b-form-select>
            </b-form-group>
            <b-form-group :label="$t('sell') + ' %'">
                <b-form-input v-model="inputSystemSell" size="sm" :state="validSell()"/>
                <b-form-text id="inputLiveHelp">
                    {{ $t('enter_value_from_to', ['40.0','80.0'])}}
                </b-form-text>
            </b-form-group>
            <b-form-group :label="$t('buy') + ' (-) %'">
                <b-form-input v-model="inputSystemBuy" size="sm" :state="validBuy()"/>
                <b-form-text id="inputLiveHelp">
                    {{ $t('enter_value_from_to', ['30.0','10.0'])}}
                </b-form-text>
            </b-form-group>
        </div>

        <div class="d-flex justify-content-end mb-3">
            <b-button @click="addSystem" size="sm">add sytem</b-button>
        </div>

        <b-table :items="getSystems" :fields="tableFields" small :class="$style.thetable" responsive>
            <template slot="table-colgroup">
                <col>
                <col>
                <col>
                <col>
                <col>
                <col>
                <col width="1">
            </template>
            <template slot="bar" slot-scope="data">
                <eco-bar :color="getEcoColor(data.item.type)" :tier="getEcoTier(data.item.wealth)"></eco-bar>
            </template>
            <template slot="type" slot-scope="data">{{ $t(data.item.type) }}</template>
            <template slot="wealth" slot-scope="data">{{ $t(data.item.wealth) }}</template>
            <template slot="sell" slot-scope="data">{{ data.item.sell }}%</template>
            <template slot="buy" slot-scope="data">{{ data.item.buy }}%</template>
            <template slot="actions" slot-scope="row">
                <font-awesome-icon icon="minus-circle" @click.stop="removeSystem(row.index)" class="icon--action text-danger"></font-awesome-icon>
            </template>
            <template slot="HEAD_actions" slot-scope="data">
                <font-awesome-icon icon="minus-circle" @click.stop="removeSystem(row.index)" class="icon--action"></font-awesome-icon>
            </template>
        </b-table>
    </div>
</template>

<script>
import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group';
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input';
import bFormText from 'bootstrap-vue/es/components/form/form-text';
import bButton from 'bootstrap-vue/es/components/button/button';
import bFormSelect from 'bootstrap-vue/es/components/form-select/form-select';
import bTable from 'bootstrap-vue/es/components/table/table';
import EcoBar from '@/components/EcoBar';
import { mapGetters, mapActions } from 'vuex';
import utils from '@/mixins/utils';

export default {
    data () {
        return {
            inputSystemName: '',
            inputSystemSell: '',
            inputSystemBuy: '',
            inputSystemType: null,
            inputSystemWealth: null,
            tableFields: [
                { key: 'name', label: this.$t('name') },
                { key: 'bar', label: '' },
                { key: 'type', label: this.$t('type') },
                { key: 'wealth', label: this.$t('wealth') },
                { key: 'sell', label: this.$t('sell') },
                { key: 'buy', label: this.$t('buy') },
                { key: 'actions', label: '' }
            ]
        };
    },
    mixins: [utils],
    components: {
        bFormGroup,
        bFormInput,
        bButton,
        bFormSelect,
        bTable,
        EcoBar,
        bFormText
    },
    computed: {
        economies () {
            return {
                types: this.$root.shared.economyTypes,
                levels: this.$root.shared.economyLevels
            };
        },
        typeOptions () {
            return this.$root.shared.economyTypes.map(type => {
                return { value: type.title, text: this.$t(type.title) };
            });
        },
        formatedSystems () {
            return this.getSystems.map(s => {
                s.type = this.$t(s.type);
                return s;
            });
        },
        ...mapGetters([
            'getSystems'
        ])
    },
    methods: {
        addSystem () {
            this.ADD_SYSTEM({
                name: this.inputSystemName,
                type: this.inputSystemType,
                wealth: this.inputSystemWealth,
                tier: this.getEcoTier(this.inputSystemWealth),
                sell: this.inputSystemSell,
                buy: this.inputSystemBuy
            })
                .then(() => {
                    this.inputSystemName = '';
                    this.inputSystemSell = '';
                    this.inputSystemBuy = '';
                    this.inputSystemType = null;
                    this.inputSystemWealth = null;
                    this.$refs.systemname.focus();
                });
        },
        removeSystem (index) {
            this.REMOVE_SYSTEM(index);
        },
        validSell () {
            if (!this.inputSystemSell.match(/^\d+[,.]?\d{0,1}$/)) return false;
            const decimal = parseFloat(this.inputSystemSell.replace(/,/, '.')).toFixed(1);
            if (decimal < 40 || decimal > 80) return false;
            return true;
        },
        validBuy () {
            if (!this.inputSystemBuy.match(/^\d+[,.]?\d{0,1}$/)) return false;
            const decimal = parseFloat(this.inputSystemBuy.replace(/,/, '.')).toFixed(1);
            if (decimal < 10 || decimal > 30) return false;
            return true;
        },
        ...mapActions([
            'ADD_SYSTEM',
            'REMOVE_SYSTEM',
            'GET_API_DATA'
        ])
    },
    mounted () {
        this.GET_API_DATA();
        this.$refs.systemname.focus();
    }
};
</script>

<style module lang="scss" scoped>
    .thetable {
        margin-bottom: 2em;
    }

    .thetable #{"/deep/"} td:nth-child(1) {
        white-space: nowrap;
    }

    .thetable #{"/deep/"} th:nth-child(3),
    .thetable #{"/deep/"} td:nth-child(3),
    .thetable #{"/deep/"} th:nth-child(4),
    .thetable #{"/deep/"} td:nth-child(4) {
        display: none;

        @media(min-width: 30em) {
            display: table-cell;
        }
    }

    .thetable #{"/deep/"} th:nth-child(5),
    .thetable #{"/deep/"} td:nth-child(5),
    .thetable #{"/deep/"} th:nth-child(6),
    .thetable #{"/deep/"} td:nth-child(6) {
        text-align: end;
    }

    .form-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-column-gap: 1em;
    }

    .form-grid *:first-child {
        grid-column: 1 / -1;
    }
</style>
